// eslint-disable-next-line no-restricted-imports
import type { Moment as _Moment } from 'moment-timezone'
// eslint-disable-next-line no-restricted-imports
import _moment from 'moment-timezone'

import { defineRussianLocale } from './momentLocaleRu'

const moment = _moment

// The locale is registered on this instance rather than imported for its side effect, because
// which moment a side effect lands on is the bundler's decision and it got it wrong. Monday is
// forced on top: these are the same calendars whichever language they are labelled in. Both calls
// make the locale they touched current, so the one that was is put back.
const current = moment.locale()
defineRussianLocale(moment)
for (const locale of ['ru', 'en']) moment.updateLocale(locale, { week: { dow: 1, doy: 4 } })
moment.locale(current)

export default moment

export type Moment = _Moment

export function assertTimezoneValid(tz: string) {
  if (!moment.tz.zone(tz)) throw new Error(`Timezone "${tz}" is invalid`)
}
